import React from "react";
import { Box, Card, CardContent, Typography, Grid, alpha } from "@mui/material";
import { AccessTime as AccessTimeIcon } from "@mui/icons-material";
import { formatTime, getDayName } from "../utils/onboardingStep3Utils";
import { OpeningHourDto } from "@swagger/typescript-fetch-goflyer";

interface OperatingHoursProps {
  openingHours: OpeningHourDto[];
}

export const OperatingHoursOnBoarding3: React.FC<OperatingHoursProps> = ({
  openingHours,
}) => (
  <Card
    elevation={1}
    sx={{
      borderRadius: 3,
      boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
      border: "1px solid",
      borderColor: alpha("#000", 0.06),
    }}
  >
    <CardContent sx={{ p: 3 }}>
      <Box display="flex" alignItems="center" mb={3}>
        <AccessTimeIcon sx={{ color: "#4caf50", mr: 1 }} />
        <Typography variant="h6" fontWeight={600}>
          Operating Hours
        </Typography>
      </Box>
      <Grid container spacing={2}>
        {openingHours.map((hours, index) => {
          if (typeof hours === "string") {
            return (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <Box
                  sx={{
                    p: 2,
                    border: "1px solid",
                    borderColor: alpha("#4caf50", 0.2),
                    borderRadius: 2,
                    backgroundColor: alpha("#4caf50", 0.05),
                  }}
                >
                  <Typography variant="body2">{hours}</Typography>
                </Box>
              </Grid>
            );
          }

          const hoursObj = hours as any;
          if (hoursObj?.open && hoursObj?.close) {
            return (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <Box
                  sx={{
                    p: 2,
                    border: "1px solid",
                    borderColor: alpha("#4caf50", 0.2),
                    borderRadius: 2,
                    backgroundColor: alpha("#4caf50", 0.05),
                  }}
                >
                  <Typography
                    variant="subtitle2"
                    fontWeight={600}
                    color="#4caf50"
                    mb={1}
                  >
                    {getDayName(hoursObj.open.day)}
                  </Typography>
                  <Typography variant="body2">
                    {formatTime(hoursObj.open.time)} -{" "}
                    {formatTime(hoursObj.close.time)}
                  </Typography>
                </Box>
              </Grid>
            );
          }
          return null;
        })}
      </Grid>
    </CardContent>
  </Card>
);
